import React, { FC } from 'react';
import { IconButton, Link, TableCell, TableRow, Tooltip } from '@mui/material';
import { formatCurrency } from 'utils/format';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import DebitCreditStatus from 'components/invoices/invoice-item/debit-credit-status/debit-credit-status.component';
import { InvoiceNote, Type } from 'models/invoice';

type DebitCreditNoteItemProps = {
    debitCreditNote: InvoiceNote;
    handleNoteClick: (debitCreditNote: InvoiceNote) => void;
    handleDeleteNote: (invoiceNoteId: string) => void;
};
const DebitCreditNoteItem: FC<DebitCreditNoteItemProps> = ({
    debitCreditNote,
    handleNoteClick,
    handleDeleteNote,
}: DebitCreditNoteItemProps) => {
    const { t: translate } = useTranslation(['invoices']);
    const textColor = debitCreditNote.type === Type.CREDIT ? 'error.main' : 'text.main';

    return (
        <TableRow hover onClick={() => handleNoteClick(debitCreditNote)}>
            <TableCell>
                <DebitCreditStatus isCredit={debitCreditNote.type === Type.CREDIT} />
            </TableCell>
            <TableCell>
                {debitCreditNote.invoice ? (
                    <Link target="_blank" href={`/invoices/${debitCreditNote.invoice?._id}/summary`}>
                        {debitCreditNote.invoice?.invoiceNumber}
                    </Link>
                ) : (
                    translate('invoices:NOT_INVOICED')
                )}
            </TableCell>
            <TableCell sx={{ minWidth: 180 }}>{debitCreditNote.clinic?.name}</TableCell>
            <TableCell sx={{ minWidth: 180 }}>{debitCreditNote.description}</TableCell>
            <TableCell>{debitCreditNote.quantity}</TableCell>
            <TableCell sx={{ color: textColor }}>
                {formatCurrency(debitCreditNote.itemPrice, debitCreditNote?.currency || '')}
            </TableCell>
            <TableCell sx={{ color: textColor }}>
                {formatCurrency(debitCreditNote.totalExclVat, debitCreditNote?.currency || '')}
            </TableCell>
            <TableCell>{debitCreditNote.itemVatPercentage}%</TableCell>
            <TableCell sx={{ color: textColor }}>
                {formatCurrency(debitCreditNote.totalIncVat, debitCreditNote?.currency || '')}
            </TableCell>
            <TableCell sx={{ maxWidth: 40 }}>
                {!debitCreditNote.invoice ? (
                    <Tooltip title={<span>{translate('invoices:DELETE_NOTE')}</span>}>
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteNote(debitCreditNote._id as string);
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : undefined}
            </TableCell>
        </TableRow>
    );
};

export default DebitCreditNoteItem;
